// components/HentaiPost.js
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Button, Spinner, ListGroup, Alert, Form, InputGroup, ButtonGroup } from 'react-bootstrap';
import { FaCopy } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import Ad from './Ad';
function HentaiPost() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const idParam = searchParams.get('id');
  const [postData, setPostData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isVideoValid, setIsVideoValid] = useState(true);
  const [invalidVideoUrl, setInvalidVideoUrl] = useState(null);
  const fetchPostData = async () => {
        setIsLoading(true);
        setError(null);

        try {
          const id = idParam.replace(/\D/g, ''); 
          const response = await fetch(
            `https://api.qwerty4-b88.workers.dev/api?id=${id}`
          );
          if (!response.ok) {
            const data = await response.json();
            if (data.error) {
              if(response.status != 420){
                throw new Error(data.error);
              }else{
                return setTimeout(()=>{fetchPostData();},2000)
              }
            } else {
              throw new Error('Failed to fetch post data');
            }
          }
          const data = await response.json();
          
          setPostData(data);

          if (data.video_src) {
            if (data.video_src.includes(".gelbooru.com/")) {
              const proxyResponse = await fetch(
                `https://cdn-host.serv00.net/proxy.php?url=${encodeURIComponent(data.video_src)}`
              );
              const proxyData = await proxyResponse.json();
              if (proxyData.proxy_url) {
                data.video_src = proxyData.proxy_url;
                setPostData(data);
                setIsVideoValid(true);
              } else {
                setIsVideoValid(false);
                setInvalidVideoUrl(data.video_src);
              }
            } else {
              const videoResponse = await fetch(
                `https://hentapi.serv00.net/?url=${encodeURIComponent(data.video_src)}`
              );
              const videoData = await videoResponse.json();
              if (videoData.status !== 200) {
                setIsVideoValid(false);
                setInvalidVideoUrl(data.video_src);
              } else {
                setIsVideoValid(true);
              }
            }
          }
          setIsLoading(false);
        } catch (err) {
          setError(err.message);
          setIsLoading(false);
        } 
      };
  useEffect(() => {
    

    if (idParam) {
      fetchPostData();
    }
  }, [idParam]);

  const handleTagClick = (tag) => {
    navigate(`/hentai_view?tag=${tag.tag_name}`);
  };

  const handleRetry = () => {
    fetchPostData();
  };

  const handleCopyVideoUrl = () => {
    navigator.clipboard.writeText(invalidVideoUrl);
  };

  if (!idParam) {
    return (
      <Container className="text-center py-5">
        <h2>No post ID provided</h2>
        <Button variant="primary" onClick={() => navigate('/')}>
          Back to Search
        </Button>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="text-center py-5">
        <h3 className="text-danger mb-3">Error: {error}</h3>
        <div className="d-flex justify-content-center gap-3">
          <Button variant="primary" onClick={() => navigate('/')}>
            Back to Search
          </Button>
          <Button variant="primary" onClick={handleRetry}>
            Try Again
          </Button>
        </div>
      </Container>
    );
  }

  if (isLoading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="light" />
      </Container>
    );
  }

  const { 
    image_src = null, 
    video_src = null, 
    is_video = false, 
    tags = [] 
  } = postData ?? {};

  
  return (<>
  <Helmet>
        <title>{postData ? `View Hentai ${idParam}` : 'Loading...'}</title>
        <meta name="description" content={
          postData ? 
          `View hentai content with tags: ${postData.tags.slice(0, 5).map(tag => tag.tag_title).join(', ')}` : 
          'Loading hentai content...'
        } />
        <meta name="keywords" content={
          postData ? 
          `hentai, ${postData.tags.map(tag => tag.tag_title).join(', ')}` : 
          'hentai, anime, manga, adult, videos'
        } />
        <meta property="og:image" content="/icon.png" />
        <link rel="icon" type="image/png" href="/icon.png" />
        <meta property="og:title" content={postData ? `View Hentai ${idParam}` : 'Loading...'} />
        <meta property="og:description" content={
          postData ? 
          `View hentai content with tags: ${postData.tags.slice(0, 5).map(tag => tag.tag_title).join(', ')}` : 
          'Loading hentai content...'
        } />
        <meta property="og:type" content="article" />
        <link rel="canonical" href={`/hentai_post?id=${idParam}`} />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
    <Container>
      <div className="text-center mb-4">
      <ButtonGroup>
         
        <Button variant="outline-primary" onClick={() => navigate(-1)}>
          ← Back to Results
        </Button> 
        <Button variant="outline-primary" onClick={() => navigate('/')}>
            Home
          </Button>
        </ButtonGroup>
      </div>

      <div className="text-center">
        {is_video && isVideoValid ? (
          <video controls src={video_src} className="img-fluid rounded" />
        ) : is_video ? (
          <div>
            <Alert variant="danger">
              The video cannot be played. Please copy the video source URL and try to view it in a new tab.
            </Alert>
            <InputGroup className="mt-3">
              <Form.Control
                type="text"
                value={invalidVideoUrl}
                readOnly
              />
              <Button variant="outline-secondary" onClick={handleCopyVideoUrl}>
                <FaCopy />
              </Button>
            </InputGroup>
          </div>
        ) : (
          <img
            src={image_src}
            alt="Post content"
            className="img-fluid rounded"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        )}
      </div>
      <div className="d-flex flex-column align-items-center">
        <Ad width={728} height={90} />
        <Ad width={468} height={60} />
        <Ad width={320} height={50} />
      </div>
      <h2 className="mt-4">Tags</h2>
      {Object.entries(
        tags.reduce((groups, tag) => {
          if (!groups[tag.tag_type]) {
            groups[tag.tag_type] = [];
          }
          groups[tag.tag_type].push(
            <ListGroup.Item
              key={tag.tag_name}
              action
              onClick={() => handleTagClick(tag)}
              style={{ cursor: 'pointer' }}
            >
              {tag.tag_title}
            </ListGroup.Item>
          );
          return groups;
        }, {})
      ).map(([tagType, tagItems]) => (
        <div key={tagType}>
          <h3>{tagType}</h3>
          <ListGroup>{tagItems}</ListGroup>
        </div>
      ))}
    </Container></>
  );
}

export default HentaiPost;